import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { updateCompOrSub as updateCompOrSubAPI} from 'services/apiComparable';

const useUpdateCompOrSub = () => {
    const queryClient = useQueryClient();
    const{isPending: isUpdating, isSuccess: isUpdated, mutate: updateCompOrSub}= useMutation({
        mutationFn: updateCompOrSubAPI,
        onSuccess:(data)=>{
            queryClient.setQueryData(['updatedCompOrSubjData'],data)
            toast.success("Updated Successfully")
            queryClient.invalidateQueries({queryKey:['compList']})
        },
        onError:(error)=>{
            console.log("Error occurred when creating Org",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
        }
    })
    return{isUpdating, isUpdated, updateCompOrSub}
}

export default useUpdateCompOrSub